const accountVisible = document.querySelectorAll(".js-account-order-visible");
gsap.fromTo(
    accountVisible,
    {
      autoAlpha: 0,
      visibility: 'hidden',
      y:20
    },
    {
      autoAlpha: 1,
      visibility: 'visible',
      y:0,
      delay: 1.2,
    }
  );

/*======================================================
  LPのcta追従ボタンが注意書きを過ぎた時の挙動
======================================================*/
gsap.to(".js-lp-fixed-visible", {
  opacity: 1,
  visibility: "visible",
  scrollTrigger: {
    trigger: "#attention",
    start: "bottom 75%", 
    toggleActions: "play none none none", 
  }
});